import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getImportantNotices, IMPORTANT_NOTICES_TAGS } from './endpoints';

const importantNoticesApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getImportantNotices: getImportantNotices(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [IMPORTANT_NOTICES_TAGS],
  });

export const { useGetImportantNoticesQuery } = importantNoticesApi;
